import React, {Component, Fragment,} from 'react';

import {APP_BOOLEANS, APPLICATION_MODES,} from 'localConstants';

import {ALERT_MESSAGES, PROPERTY_RESPONSE_TEMPLATES,} from '../../../../../constants/appConstants';
import {trimCapitalize} from '../../../../../utils/stringUtil';
import {TatvamButton, TatvamCol, TatvamGrid, TatvamModal,} from '../../../../functionalComponents/index';
import AlertBox from '../../../alertBox';
import CustomerResponseTemplateForm from '../../../customerResponseTemplateForm';

class ResponseTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            responseTemplateModal: false,
            responseTemplateGridData: [],
            loader: true,
            colDef: [
                {
                    headerName: PROPERTY_RESPONSE_TEMPLATES.VIEW_TEMPLATE_NAME,
                    field: "template_name",
                    filterParams: {clearButton: true}
                },
                {
                    headerName: PROPERTY_RESPONSE_TEMPLATES.VIEW_SOURCE_NAME,
                    field: "sourcename",
                    filterParams: {clearButton: true}
                },
                {headerName: PROPERTY_RESPONSE_TEMPLATES.STATUS, field: "status", filterParams: {clearButton: true}}]
        };

    }

    _handleDeleteConfirmation = (data) => {
        this.setState({
            idCustomer: data.customer_id,
            id: data.id,
            isConfirmBox: true,
            isAlertBoxOpen: false,
            isDeleteAlertBoxOpen: true,
            isSuccess: false,
            alert_information: ALERT_MESSAGES.DELETE_CONFIRMATION
        });
    };
    _deleteRow = (data) => {
        if (data === "ok") {
            let customer_id = this.state.idCustomer;
            let id = this.state.id;
            let templateDeleteData = {
                customer_id,
                id

            };
            this.props.actions.deleteCustomerResponseTemplate(templateDeleteData).then((response) => {
                this.setState({
                    preLoader: false
                });

                if (response.status === 200) {
                    this.setState({
                        shouldCloseModal: true,
                        isAlertBoxOpen: true,
                        isSuccess: true,
                        alert_information: response.data.message
                    });
                } else {
                    this.setState({
                        shouldCloseModal: false,
                        isAlertBoxOpen: true,
                        isSuccess: false,
                        alert_information: response.data ? response.data.message : response.message
                    });
                }
            });

        }
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false,
            isDeleteAlertBoxOpen: false
        });
    }
    _discard = (data) => {
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false
        });
    };

    _addReponseTemplate = () => {
        this.setState({
            selectedResponseTemplateData: [],
            applicationMode: APPLICATION_MODES.CREATE,
            responseTemplateModal: true,
            title: PROPERTY_RESPONSE_TEMPLATES.ADD_RESPONSE_TEMPLATE
        }, () => {
            this.setState({
                responseTemplateModal: true
            });
        });
    };
    closeModal = () => {
        this.setState({
            responseTemplateModal: false
        });
    };
    _openViewModal = data => {
        this.setState({
            selectedResponseTemplateData: data[0],
            applicationMode: APPLICATION_MODES.VIEW,
            responseTemplateModal: false,
            title: ""

        }, () => {
            this.setState({
                responseTemplateModal: true
            });
        });
    };

    componentDidMount() {
        this.setState({
            loader: true
        });
        this.props.actions.fetchCustomerResponseTemplates(this.props.currentCustomerId).then(() => {
            this.setState({
                loader: false
            });

            let responseTemplateGridData = [];
            if (this.props.responseTemplateLst) {
                this.props.responseTemplateLst.map((data) => {
                    let status = trimCapitalize(data.status);
                    if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                        var item = data;
                        if (data.source_name && data.comment_type) {
                            item.sourcename = data.source_name + " - " + data.comment_type;
                        } else {
                            item.sourcename = "";
                        }

                        responseTemplateGridData.push(data);
                    }
                });
            }

            this.setState({
                responseTemplateGridData
            }, () => {
                const gridData = this.state.responseTemplateGridData;
                const noOfActive = gridData.filter(eachItem => eachItem.status === 'Active');
                this.props.countPropagate({
                    'responseTemplateSource': {
                        'active': noOfActive.length,
                        'total': gridData.length
                    }
                });
            });
        });
    }

    componentWillReceiveProps(props) {
        let responseTemplateGridData = [];
        if (props.responseTemplateLst) {
            props.responseTemplateLst.map((data) => {
                let status = trimCapitalize(data.status);
                if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                    var item = data;
                    if (data.source_name && data.comment_type) {
                        item.sourcename = data.source_name + " - " + data.comment_type;
                    } else {
                        item.sourcename = "";
                    }
                    responseTemplateGridData.push(item);
                }
            });
        }

        this.setState({
            responseTemplateGridData
        }, () => {
            const gridData = this.state.responseTemplateGridData;
            const noOfActive = gridData.filter(eachItem => eachItem.status === 'Active');
            this.props.countPropagate({
                'responseTemplateSource': {
                    'active': noOfActive.length,
                    'total': gridData.length
                }
            });
        });
    }

    render() {
        return (
            <Fragment>
                {/* <TatvamButton className="mt-1 ml-1 mr-1 mb-1 right
        btn_primary" name="editRole" onClick={this._addRole}>  Edit Role</TatvamButton> */}
                {this.props.responsePermission === APP_BOOLEANS.TRUE && (
                    < TatvamButton
                        className="mt-1 ml-2 mr-2 right btn_primary"
                        name="addRole"
                        onClick={this._addReponseTemplate}
                    >
                        {PROPERTY_RESPONSE_TEMPLATES.ADD_RESPONSE_TEMPLATE}
                    </TatvamButton>
                )}

                {
                    this.state.responseTemplateModal && (
                        <TatvamModal
                            open={this.state.responseTemplateModal}
                            className="hideFooter"
                            header={this.state.title}
                            options={{dismissible: false}}
                            fixedFooter={false}
                            children={(
                                <CustomerResponseTemplateForm
                                    responseTemplateData={this.state.selectedResponseTemplateData}
                                    currentCustomerId={this.props.currentCustomerId}
                                    closeModal={this.closeModal}
                                    title={this.state.title}
                                    operationsList={this.props.operationsList}
                                    reportsList={this.props.reportsList}
                                    applicationMode={this.state.applicationMode}
                                />
                            )}
                        />

                    )}

                {this.state.responseTemplateGridData && this.state.responseTemplateGridData.length > 0 ? (
                    <TatvamCol s={12} className="roleGrid grid-data-area">
                        <TatvamGrid
                            gridData={this.state.responseTemplateGridData}
                            colData={this.state.colDef}
                            enableRowClick
                            onRowSelect={this._openViewModal}
                            enableDeleteColumn={this.props.responseDelete === APP_BOOLEANS.TRUE}
                            onRowDelete={this._handleDeleteConfirmation}
                        />

                    </TatvamCol>
                ) : this.state.loader ? (
                    <TatvamCol s={12} className="grid-empty-area">
                        <h5>
                            Loading...
                        </h5>

                    </TatvamCol>
                ) : (
                    <TatvamCol s={12} className="grid-empty-area">
                        <h5>
                            {PROPERTY_RESPONSE_TEMPLATES.NO_RESPONSE_TEMPLATE_AVAILABLE}
                        </h5>

                    </TatvamCol>
                )}
                {this.state.isAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._discard}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
                {this.state.isDeleteAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isDeleteAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._deleteRow}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
            </Fragment>
        );
    }
}

export default ResponseTemplates;
